export default __webpack_public_path__ + "static/media/locked.1d113436.svg";